var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgRespiratory = function SvgRespiratory(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 84 84"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#respiratory_svg__a)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 52,
    height: 52,
    x: 16,
    y: 12,
    fill: "#fff",
    rx: 8,
    shapeRendering: "crispEdges"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#1F4970",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5,
    d: "M40.437 34.963c-.136-.556-.228-1.089-.398-1.595a15 15 0 0 0-.778-1.982 2.694 2.694 0 0 0-3.726-1.37 8.2 8.2 0 0 0-2.226 1.416 22.4 22.4 0 0 0-5.026 6.431 18.4 18.4 0 0 0-1.877 4.696 12.6 12.6 0 0 0-.35 2.392 158 158 0 0 0-.051 5.815c-.016.97.123 1.937.41 2.864a2.72 2.72 0 0 0 2.641 2.066q.125.016.244.054h.128c.283-.034.568-.058.85-.103a13.4 13.4 0 0 0 5.576-2.398 13.15 13.15 0 0 0 4.044-4.324 7.65 7.65 0 0 0 1.045-3.993q-.077-3.272-.147-6.544c-.02-1.15-.14-2.296-.36-3.425M44.857 34.694c.043-.188.075-.32.102-.451a10 10 0 0 1 1.076-3.055 2.72 2.72 0 0 1 2.232-1.549 3.64 3.64 0 0 1 1.867.465 12.3 12.3 0 0 1 3.573 2.955 24.7 24.7 0 0 1 4.31 6.9c.79 1.752 1.2 3.65 1.205 5.572-.01.445.033.89.051 1.336v4.09c-.021.166-.034.334-.065.498a20 20 0 0 1-.448 2.242 2.51 2.51 0 0 1-1.953 1.819 5.5 5.5 0 0 1-2.683-.138 14.58 14.58 0 0 1-8.509-6.12 7.5 7.5 0 0 1-1.305-4.335c.042-2.224.1-4.448.148-6.671.026-1.196.16-2.386.399-3.558"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#1F4970",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5,
    d: "M42.425 19.75v12.764a5.92 5.92 0 0 1-2.145 4.591 21.5 21.5 0 0 1-5.746 3.175s-3.693 1.547-5.093 7.032"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#1F4970",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5,
    d: "M34.422 45.465s-.367-4.14.908-5.512M31.232 38.475s1.655 1.805 5.08 1.04M42.425 19.75v12.764a5.92 5.92 0 0 0 2.145 4.591 21.5 21.5 0 0 0 5.746 3.175s3.694 1.547 5.093 7.032"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#1F4970",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5,
    d: "M50.428 45.465s.367-4.14-.907-5.512M53.618 38.475s-1.654 1.805-5.08 1.04"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "respiratory_svg__a",
    width: 84,
    height: 84,
    x: 0,
    y: 0,
    colorInterpolationFilters: "sRGB",
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    "in": "SourceAlpha",
    result: "hardAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 8
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0.745833 0 0 0 0 0.745833 0 0 0 0 0.745833 0 0 0 0.64 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_2710_35581"
  }), /*#__PURE__*/React.createElement("feBlend", {
    "in": "SourceGraphic",
    in2: "effect1_dropShadow_2710_35581",
    result: "shape"
  })))));
};
export default SvgRespiratory;